import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LogService } from '../log/log.service';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CanActivateViaGuestGuard implements CanActivate {

  constructor(private router: Router,
              private authService: AuthenticationStore,
              private logService: LogService) {
  }

  canActivate(): Observable<boolean> {
    this.logService.debug('Checking if the user is already authenticated. If so, then redirect to the secure site');
    return this.authService.isLoggedIn().map(isLoggedIn => {
      if (isLoggedIn) {
        this.router.navigate([ '/' ]);
      }

      // Returning !isLoggedIn since we only want to activate the guard is the user is not logged in.
      return !isLoggedIn;
    });
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/can-activate-via-guest-guard.ts